import { render, staticRenderFns } from "./f-swiper.vue?vue&type=template&id=9df1e0a2&scoped=true"
import script from "./f-swiper.vue?vue&type=script&lang=js"
export * from "./f-swiper.vue?vue&type=script&lang=js"
import style0 from "./f-swiper.vue?vue&type=style&index=0&id=9df1e0a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.90.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df1e0a2",
  null
  
)

export default component.exports